import { CONFIG } from '@ligr/shared';

export const clearLocalToken = () => localStorage.removeItem(CONFIG.LOCAL_STORAGE_TOKEN_KEY);

export const getLocalToken = () => localStorage.getItem(CONFIG.LOCAL_STORAGE_TOKEN_KEY);

export const setLocalToken = (token: string) => localStorage.setItem(CONFIG.LOCAL_STORAGE_TOKEN_KEY, token);
